import React, { Component } from 'react';
import {Link} from 'react-router';

export default class MainMenu extends Component {

  render() {
    return (
      <div className="grid_16" id="mainMenu">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/photos">Gallery</Link></li>
          <li><Link to="/testimonials">Testimonials</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/MainMenu.js
 **/